"use client";

import { c as _c } from "react/compiler-runtime";
import { useIsLessThan2Xl, useIsLessThanXl } from "@opensea/ui-kit";
import { useEffect, useState } from "react";
import { createContext } from "use-context-selector";
import { useFilterSidePanel } from "./FilterSidePanelProvider";
import { useSideModule } from "./SideModuleProvider";
export const FilterLayoutContext = createContext({
  page: undefined,
  isFilterSidePanelOpen: false,
  setIsFilterSidePanelOpen: () => undefined,
  isFilterSheetOpen: false,
  setIsFilterSheetOpen: () => undefined,
  isSideModuleOpen: false,
  setIsSideModuleOpen: () => undefined,
  isSideModuleSheetOpen: false,
  setIsSideModuleSheetOpen: () => undefined
});
export function FilterLayoutProvider(t0) {
  const $ = _c(27);
  const {
    children,
    page
  } = t0;
  const {
    isFilterSidePanelOpen,
    setIsFilterSidePanelOpen
  } = useFilterSidePanel();
  const [isFilterSheetOpen, setIsFilterSheetOpen] = useState(false);
  const {
    isSideModuleOpen,
    setIsSideModuleOpen
  } = useSideModule();
  const [isSideModuleSheetOpen, setIsSideModuleSheetOpen] = useState(false);
  const isLessThan2xl = useIsLessThan2Xl();
  const isLessThanXl = useIsLessThanXl();
  let t1;
  if ($[0] !== isLessThan2xl || $[1] !== isSideModuleOpen || $[2] !== setIsFilterSidePanelOpen || $[3] !== setIsSideModuleOpen) {
    t1 = function handleFilterSidePanelOpen(open) {
      if (open && isLessThan2xl && isSideModuleOpen) {
        setIsSideModuleOpen(false);
      }
      setIsFilterSidePanelOpen(open);
    };
    $[0] = isLessThan2xl;
    $[1] = isSideModuleOpen;
    $[2] = setIsFilterSidePanelOpen;
    $[3] = setIsSideModuleOpen;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleFilterSidePanelOpen = t1;
  let t2;
  if ($[5] !== isFilterSidePanelOpen || $[6] !== isLessThan2xl || $[7] !== setIsFilterSidePanelOpen || $[8] !== setIsSideModuleOpen) {
    t2 = function handleFilterSideModuleOpen(open_0) {
      if (open_0 && isLessThan2xl && isFilterSidePanelOpen) {
        setIsFilterSidePanelOpen(false);
      }
      setIsSideModuleOpen(open_0);
    };
    $[5] = isFilterSidePanelOpen;
    $[6] = isLessThan2xl;
    $[7] = setIsFilterSidePanelOpen;
    $[8] = setIsSideModuleOpen;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const handleFilterSideModuleOpen = t2;
  let t3;
  let t4;
  if ($[10] !== isFilterSidePanelOpen || $[11] !== isLessThan2xl || $[12] !== isSideModuleOpen || $[13] !== setIsSideModuleOpen) {
    t3 = () => {
      if (isLessThan2xl && isFilterSidePanelOpen && isSideModuleOpen) {
        setIsSideModuleOpen(false);
      }
    };
    t4 = [isFilterSidePanelOpen, isLessThan2xl, isSideModuleOpen, setIsSideModuleOpen];
    $[10] = isFilterSidePanelOpen;
    $[11] = isLessThan2xl;
    $[12] = isSideModuleOpen;
    $[13] = setIsSideModuleOpen;
    $[14] = t3;
    $[15] = t4;
  } else {
    t3 = $[14];
    t4 = $[15];
  }
  useEffect(t3, t4);
  const t5 = isLessThanXl ? false : isFilterSidePanelOpen;
  const t6 = isLessThanXl ? false : isSideModuleOpen;
  let t7;
  if ($[16] !== handleFilterSideModuleOpen || $[17] !== handleFilterSidePanelOpen || $[18] !== isFilterSheetOpen || $[19] !== isSideModuleSheetOpen || $[20] !== page || $[21] !== t5 || $[22] !== t6) {
    t7 = {
      page,
      isFilterSidePanelOpen: t5,
      setIsFilterSidePanelOpen: handleFilterSidePanelOpen,
      isSideModuleOpen: t6,
      setIsSideModuleOpen: handleFilterSideModuleOpen,
      isFilterSheetOpen,
      setIsFilterSheetOpen,
      isSideModuleSheetOpen,
      setIsSideModuleSheetOpen
    };
    $[16] = handleFilterSideModuleOpen;
    $[17] = handleFilterSidePanelOpen;
    $[18] = isFilterSheetOpen;
    $[19] = isSideModuleSheetOpen;
    $[20] = page;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  const value = t7;
  let t8;
  if ($[24] !== children || $[25] !== value) {
    t8 = <FilterLayoutContext.Provider value={value}>{children}</FilterLayoutContext.Provider>;
    $[24] = children;
    $[25] = value;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  return t8;
}